import React, { ReactNode } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    List,
    Menu,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import {
    generateListItem,
    lgOverlayStyles,
    radioOptions,
} from './lifegraph-overlay-helper';

interface LifeGraphOverlayProps {
    children: ReactNode;
    displayMode: string;
    showGraphBtn: boolean;
    onDisplayModeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LifeGraphOverlay = ({
    children,
    displayMode,
    onDisplayModeChange,
    showGraphBtn,
}: LifeGraphOverlayProps): React.JSX.Element => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleGraphButtonClick = (
        event: React.MouseEvent<HTMLButtonElement>
    ): void => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (): void => {
        setAnchorEl(null);
    };

    return (
        <Box sx={lgOverlayStyles.overlayContainer}>
            {children}
            <Box sx={lgOverlayStyles.graphContainer}>
                {showGraphBtn && (
                    <Button
                        sx={lgOverlayStyles.graphBtn}
                        onClick={handleGraphButtonClick}
                    >
                        <Icon
                            icon='mdi-cog'
                            style={lgOverlayStyles.cogIcon}
                        ></Icon>
                        <Typography sx={lgOverlayStyles.btnTitle}>
                            Graph Settings
                        </Typography>
                    </Button>
                )}
                <Menu
                    id='basic-menu'
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    sx={lgOverlayStyles.menu}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                >
                    <FormControl sx={lgOverlayStyles.formControl}>
                        <Box sx={lgOverlayStyles.menuTitleContainer}>
                            <Icon
                                icon='mdi-cog'
                                style={lgOverlayStyles.menuTitleIcon}
                            ></Icon>
                            <Typography sx={lgOverlayStyles.menuTitle}>
                                Node Style
                            </Typography>
                        </Box>
                        <RadioGroup
                            row
                            value={displayMode}
                            name='graph-style-buttons-group'
                            onChange={onDisplayModeChange}
                        >
                            {radioOptions.map((val) => (
                                <FormControlLabel
                                    key={val}
                                    value={val}
                                    control={<Radio />}
                                    label={val}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                    <Box>
                        <Box sx={lgOverlayStyles.menuTitleContainer}>
                            <Icon
                                icon='mdi-camera-control'
                                style={lgOverlayStyles.menuTitleIcon}
                            ></Icon>
                            <Typography sx={lgOverlayStyles.menuTitle}>
                                Controls
                            </Typography>
                        </Box>
                        <List>
                            {generateListItem('Rotate', 'Left-click')}
                            {generateListItem(
                                'Zoom',
                                'Mouse-wheel/<br/>middle-click'
                            )}
                            {generateListItem('Pan', 'Right-click')}
                        </List>
                    </Box>
                </Menu>
            </Box>
        </Box>
    );
};
